import React from 'react';
import { CountryFlag, NumberString, PriceString } from '@fourthwall/components';
import { TimezonedDateString } from '../../../../../../../../Timezone/components/TimezonedDateString';
const DATE_FORMATS = {
    hour: 'MMM D, YYYY h:mm A',
    day: 'MMM D, YYYY',
    month: 'MMM YYYY',
};
export const AnalyticsTableCellValueFormat = ({ value, type, precision, }) => {
    if (value === null || value === undefined) {
        return '-';
    }
    // Date
    if (type === 'date') {
        // Date range
        if (typeof value === 'object' && 'from' in value && 'to' in value) {
            return (React.createElement(React.Fragment, null,
                React.createElement(TimezonedDateString, { date: value.from, format: "MMM D, YYYY" }),
                " -",
                ' ',
                React.createElement(TimezonedDateString, { date: value.to, format: "MMM D, YYYY" })));
        }
        // Single date
        return (React.createElement(TimezonedDateString, { date: value, format: DATE_FORMATS[precision || 'day'], withTimezoneAbbreviation: false }));
    }
    // Money
    if (type === 'money' && typeof value === 'object' && 'value' in value && 'currency' in value) {
        return React.createElement(PriceString, { value: value.value, currency: value.currency });
    }
    if (type === 'country') {
        return React.createElement(CountryFlag, { countryCode: value, size: 20 });
    }
    // Number
    if (type === 'number') {
        if (value === '') {
            return 0;
        }
        return React.createElement(NumberString, { value: value });
    }
    // Boolean
    if (type === 'boolean') {
        return value ? 'Yes' : 'No';
    }
    // Percentage
    if (type === 'percentage') {
        if (value === '') {
            return '0%';
        }
        return `${value}%`;
    }
    if (type === 'string') {
        if (value === '') {
            return '-';
        }
        return value;
    }
    return typeof value === 'string' ? value : value.toLocaleString();
};
